import { ErrorHandler, Injectable, Injector, inject } from '@angular/core'
import { AppVersionUpdateService } from 'src/app/data/services/application/app-version-update/app-version-update.service'
import { isChunkLoadError } from 'src/app/domain/utils/functions/is-chunk-load-error'

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private injector: Injector = inject(Injector)

  public handleError(error: unknown): void {
    if (isChunkLoadError(error)) {
      this.injector.get(AppVersionUpdateService).showIfChunkLoadError(error)
      return
    }
    console.error(error)
  }
}
